// extracted by mini-css-extract-plugin
export var box = "_53-0";
export var check = "_53-1";
export var checkboxButton = "_53-6";
export var checkboxGroup = "_53-5";
export var disabled = "_53-7";
export var ghost = "_53-9";
export var input = "_53-2";
export var label = "_53-4";
export var normal = "_53-8";
export var uncheck = "_53-3";